export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd1633981b95c5e218f8e407f27b053289ba5a7a8&name=fetchTypeahead!'